document.addEventListener('DOMContentLoaded', () => {

  const openerSection = document.querySelector('.section-animated-opener');
  const aoContainer   = openerSection?.querySelector('.ao-container');
  const cascadeItems  = aoContainer ? aoContainer.querySelectorAll('.cascadeItem') : [];
  const imageWrapper  = openerSection?.querySelector('.ao-image-wrapper');
  const background    = openerSection?.querySelector('.ao-animated-bg');
  const header = document.querySelector('.header-wrapper');

  if (!openerSection || !aoContainer || !background || !header) return;

  // set Header height 
  const setHeaderHeightVar = () => {
    const h = header.getBoundingClientRect().height || 72;
    document.documentElement.style.setProperty('--sticky-header-height', `${h}px`);
  };
  setHeaderHeightVar();

  let resizeRaf;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(setHeaderHeightVar);
  }, { passive: true });

  // Prepare header
  header.classList.add('header--prepared');
  header.classList.remove('header--visible');

  const triggerPoint = window.innerHeight * 0.3;
  let lastCascadeState = false;

  function toggleCascadeAndHeader(scrolled) {
    if (scrolled === lastCascadeState) return;

    // Cascade items
    cascadeItems.forEach((item) => {
      const index = parseInt(item.dataset.index || '0', 10);
      const delay = scrolled ? index * 100 : (cascadeItems.length - 1 - index) * 100;

      setTimeout(() => {
        item.classList.toggle('scrolled', scrolled);
        item.querySelectorAll('.cascadeColor').forEach(el => el.classList.toggle('scrolled', scrolled));
      }, delay);
    });

    if (imageWrapper) imageWrapper.classList.toggle('scrolled', scrolled);
    background.classList.toggle('scrolled', scrolled);

    // Header reveal synced with same flag
    header.classList.toggle('header--visible', scrolled);

    lastCascadeState = scrolled;
  }

  // Scroll listener
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY >= triggerPoint;
    toggleCascadeAndHeader(scrolled);
  }, { passive: true });
});

